import Button from "../../components/Button/Button";
import NavBar from "../../components/NavBar/NavBar";
import "./HomePage.scss";
import logo1 from "../../assets/homepage/logo1.png";
import logo2 from "../../assets/homepage/logo2.png";
import logo3 from "../../assets/homepage/logo3.png";
import logo4 from "../../assets/homepage/logo4.png";
import logo5 from "../../assets/homepage/logo5.png";
import twinkle from "../../assets/homepage/twinkle.png";
import questionsPage from "../../assets/oq/questionsPage.png";
import modulesPage from "../../assets/oq/modulesPage.png";
import forStudentsImg from "../../assets/homepage/forStudentsImg.svg";
import forSchoolsImg from "../../assets/homepage/forSchoolsImg.svg";
import circles from "../../assets/homepage/circles.svg";
import { Button as BootstrapButton } from "react-bootstrap";

import dashboardPage from "../../assets/oq/Dashboard.png";
import Checkmark from "../../components/Checkmark/Checkmark";
import Footer from "../../components/Footer/Footer";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import products from "../SignUpPage/products";

const OqHomePage = () => {

  const { pathname, hash, key } = useLocation();
  const navigate = useNavigate();

  const newsletterFormSubmitted = (event: any) => {
    event.preventDefault();
    console.log(event);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      }
    } else {
      window.scrollTo(0, 0)
    }
  }, [hash])

  return (
    <div id="OqHomePage">
      <NavBar />
      <div className="landing-section">
        <div className="landing-section-background">
          <div className="landing-section-left"></div>

          <div className="landing-section-image"></div>
        </div>

        <div className="landing-section-overlay" style={{
          zIndex: 1,
        }}>
          <div className="site-container">
            <div>
              <h1>
                Master the FRCOphth Exams
              </h1>
              <p>
                Join our <strong>premium platform</strong> for Ophthalmology exam preparation for the <strong>FRCOphth part 1, FRCOphth part 2</strong>, <strong>MSRA exam, and Ophthalmology interviews</strong>.
              </p>
              <Button text="Sign Up Now" linkTo="/sign-up" />
            </div>
          </div>
        </div>

        {/* <div className="landing-section-overlay" style={{
          zIndex: 0
        }}>
          <div id="logoImage" className="image"></div>
          <div id="gradesImage" className="image"></div>
          <div id="mathsCardImage" className="image"></div>
        </div> */}
      </div>

      <div id="other-sections">

        {/* <section id="supported-by">



          <div className="supported-by-wrapper">
            <h2>Supported By</h2>
            <img src={twinkle} alt="Twinkle" />
          </div>


          <div className="supported-by-logos">

            <div className="site-container">


              <img src={logo1} alt="University of Birmingham logo" />
              <img src={logo2} alt="Start Up Awards Finalist 2023 logo" />
              <img
                src={logo3}
                alt="University of Birmingham Elevate Programme at the Exchange logo"
              // style={{ padding: "40px" }}
              />
              <img
                src={logo4}
                alt="Innovation Awards 2023 logo"
              // style={{ padding: "40px" }}
              />
              <img src={logo5} alt="University of Cambridge logo" />

            </div>

          </div>




        </section> */}

        <section id="about-oq">
          <div className="site-container">
            <div className="for-students-or-schools-inner-wrapper" style={{
              paddingTop: '50px',
            }}>
              <div className="for-students-or-schools-details">
                <h2>About OQ</h2>
                <ul>
                  <li>
                    <Checkmark />
                    Quality questions: realistic questions in line with <strong>FRCOphth</strong> exams.
                  </li>
                  <li>
                    <Checkmark />
                    Flexible Testing: On-demand practice exams anytime, anywhere
                  </li>
                  <li>
                    <Checkmark />
                    Tracking: Monitor scores and topic mastery in one place
                  </li>
                  <li>
                    <Checkmark />
                    Instant & extensive feedback: with latest up-to-date explanations taken from UK guidelines
                  </li>
                </ul>
              </div>
              <div className="for-students-or-schools-image-wrapper">
                <div className="gradient-background">
                  <img src={questionsPage} alt="Question Page" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="why-us">
          <div className="site-container">
            <div className="for-students-or-schools-inner-wrapper">
              <div className="for-students-or-schools-image-wrapper">
                <div className="gradient-background">
                  <img
                    src={modulesPage}
                    alt="Modules Page"
                  />
                </div>
              </div>
              <div className="for-students-or-schools-details">
                <h2>Why Choose OQ?</h2>
                <ul>
                  <li>
                    <Checkmark />
                    Created by Ophthalmologist for Ophthalmologists
                  </li>
                  <li>
                    <Checkmark />
                    Extensive content with 1000s of questions overall
                  </li>
                  <li>
                    <Checkmark />
                    Covers <strong>FRCOphth Parts 1 & 2, & MSRA exams</strong>
                  </li>
                  <li>
                    <Checkmark />
                    Regular updates to platform and questions
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="our-vision" className="image">
          <div className="site-container">
            <h2>Our Vision</h2>
            <p>
              Our vision is to the be the gold-standard platform helping you prepare with the upmost confidence and ace the FRCOpth exams, MSRA, and Duke Elder exam.
            </p>

            <div className="vision-wrapper">
              <div className="vision-card">
                <p>
                  <Checkmark />
                  MSRA
                </p>
              </div>

              <div className="vision-card">
                <p>
                  <Checkmark />Duke Elder
                </p>
              </div>

              <div className="vision-card">
                <p>
                  <Checkmark />
                  FRCOphth Part 1
                </p>
              </div>

              <div className="vision-card">
                <p>
                  <Checkmark />
                  FRCOphth Part 2
                </p>
              </div>
            </div>

            <div id="dashboard-image-showcase-wrapper">
              <img
                src={dashboardPage}
                alt="Dashboard page"
                id="dashboard-image-showcase"
              />
            </div>
          </div>
        </section>

        <section id="pricing">
          <div className="site-container">
            <h2>Question Banks and Resources</h2>
            <p>
              Prepare best for your <strong>FRCOphth</strong> examinations. Sign up to our question banks and keep up today!
            </p>

            <div className="oq-product-cards-wrapper">
              {products.map(product => {
                const isPurchasable = !(product as any).purchasable === false;
                let button = (
                  <>
                    <BootstrapButton onClick={() => {
                      navigate('/products/' + product.id)
                    }} style={{
                      width: '100%',
                      fontWeight: 'bold',
                      borderColor: '#0e4f99',
                      backgroundColor: '#0e4f99',
                      marginBottom: isPurchasable && !product.comingSoon ? '10px' : '0'
                    }}>Learn More</BootstrapButton>
                    {isPurchasable && !product.comingSoon && (
                      <BootstrapButton onClick={() => {
                        const checkoutUrl = (product as { checkoutUrl?: string }).checkoutUrl;
                        if (checkoutUrl) {
                          window.open(checkoutUrl, "_blank", "noopener,noreferrer");
                        } else {
                          navigate('/sign-up?product=' + product.id);
                        }
                      }} style={{
                        width: '100%',
                        fontWeight: 'bold',
                        borderColor: '#0e4f99',
                        backgroundColor: '#0e4f99'
                      }}>Purchase</BootstrapButton>
                    )}
                  </>
                )
                return (
                  <div className={`oq-product-card ${product.css}`} key={product.id}>
                    <h5>{product.title}</h5>
                    <p>{product.description}</p>
                    <p className="oq-product-card-pricing">
                      {product.price ? (
                        <>
                          <span>£{product.price}</span> / {product.length}
                          {product.comingSoon && (
                            <span className="coming-soon-pill">coming soon</span>
                          )}
                        </>
                      ) : (
                        <>
                          <span style={{
                            visibility: 'hidden'
                          }}>£</span>
                        </>
                      )}
                    </p>
                    {button}
                  </div>
                )
              })}
            </div>
          </div>
        </section>

        <section id="newsletter" className="image">
          <div className="site-container">
            <h2>Subscribe to our Newsletter</h2>

            <p>
              Be the first to know when OphthalmologyQ has new updates and gain exclusive
              access to special offers, study tips, and educational insights.
              Subscribe to our newsletter today!
            </p>

            <form onSubmit={newsletterFormSubmitted}>
              <input
                type="email"
                name="email"
                placeholder="Enter your email address here..."
              />
              <div className="email-submit-button-wrapper">
                <Button text="Subscribe" submit />
              </div>
            </form>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default OqHomePage;
